import { Component, OnInit } from '@angular/core';
import { TimeoutService } from '../../../services/timeout.service';
import { UserService } from '../../../services/user.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.less'],
  standalone: false
})
export class TimeoutComponent implements OnInit {
  constructor(
    private timeoutService: TimeoutService,
    private userService: UserService,
    private msalService: MsalService
  ) { }

  time: number = null;

  private sessionRenewing: boolean = false;
  private timeoutInterval = null;
  popupVisibility: boolean;

  ngOnInit(): void {
    setInterval(() => this.checkSession(), 10000);
  }

  private checkSession(): void {
    if (this.timeoutService.sessionValidTo == null) {
      return;
    }

    if (this.sessionRenewing) {
      return;
    }

    const timeToShowDialog: number = 3 * 60 * 1000;

    var timeToExpire = this.timeoutService.sessionValidTo.getTime() - Date.now();

    if (timeToExpire > timeToShowDialog) {
      return;
    }

    this.sessionRenewing = true;

    var time = this.timeoutService.sessionValidTo.getTime() - Date.now();

    if (time >= 0) {
      this.time = time;
    }

    this.timeoutInterval = setInterval(() => {
      time = this.timeoutService.sessionValidTo.getTime() - Date.now();

      if (time >= 0) {
        this.time = time;
      } else {
        this.logout();
      }
    }, 1000);

    this.popupVisibility = true;
  }

  continueSession(): void {
    this.userService.renewSession();

    this.sessionRenewing = false;
    this.popupVisibility = false;

    clearInterval(this.timeoutInterval);
  };

  logout(): void {
    this.msalService.logout();
  };

  ngOnDestroy(): void {
    if (this.timeoutInterval) {
      clearInterval(this.timeoutInterval);
    }
  }
}
